module.exports = __webpack_public_path__ + "static/media/logo.30bd599a.png";